import usePageMeta from '@/hooks/usePageMeta';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ProductsHero from './components/ProductsHero';
import ProductsItems from './components/ProductsItems';
import ProductsCTA from './components/ProductsCTA';

const ProductsPage = () => {
  usePageMeta({
    title: '製品一覧 | 株式会社MSK',
    ogTitle: '製品一覧 | 株式会社MSK',
    description: '株式会社MSKが提供するソフトウェア・ツールを掲載しています。業務でお役立ていただけるものを、順次公開していきます。',
  });

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <ProductsHero />
        <ProductsItems />
        <ProductsCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ProductsPage;